import type { CSSProperties } from "react";

export const BOOKER_DIALOG_ID = "wa-booker-dialog";

/** Matches Trekker's `md` breakpoint, where modal panes stop being full-screen. */
export const CATALOG_WIDE_MIN_WIDTH = 768;

const CATALOG_PANE_WIDTH = 820;

/** Backdrop for panes opened over the store: it stays visible but can't be used. */
export const STORE_FROZEN_BACKDROP_STYLE: CSSProperties = {
  background: "rgba(0, 0, 0, 0.6)",
};

/**
 * Trekker's pane placements cap out at 520px and don't accept a width override,
 * so the grid store widens its own dialog by id. Panes opened over it (product
 * details, checkout) keep the regular booker width.
 */
export const CatalogPaneStyles = () => (
  <style>{`
    @media (min-width: ${CATALOG_WIDE_MIN_WIDTH}px) {
      #${BOOKER_DIALOG_ID} {
        width: min(${CATALOG_PANE_WIDTH}px, 100vw);
      }
    }
  `}</style>
);
